import type { FormPickerOption } from '@/components/molecules/FormPicker';

/** Shared with anchor measurement (web desktop dropdown max height). */
export const OPTION_PICKER_DROPDOWN_MAX_HEIGHT = 280;

export interface OptionPickerAnchorRect {
    x: number;
    y: number;
    width: number;
    height: number;
    /** Web: menu flipped above the trigger when viewport is tight. */
    opensUpward?: boolean;
}

export interface OptionPickerModalProps {
    visible: boolean;
    title: string;
    options: FormPickerOption[];
    selectedKey?: string | null;
    onSelect: (option: FormPickerOption) => void;
    onClose: () => void;
    loading?: boolean;
    /** Web desktop: position menu under the FormPicker trigger (mat-select style). */
    anchor?: OptionPickerAnchorRect | null;
}
